"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootStoreContext = exports.RootStore = void 0;
var react_1 = require("react");
var ModalStore_1 = require("./ModalStore");
var AuthenticationStore_1 = require("./AuthenticationStore");
var AuthorizationStore_1 = require("./AuthorizationStore");
var BaseApiService_1 = require("../services/BaseApiService");
var TransactionStore_1 = require("./TransactionStore");
var RootStore = /** @class */ (function () {
    function RootStore() {
        this.authenticationStore = new AuthenticationStore_1.default(this);
        this.authorizationStore = new AuthorizationStore_1.default(this);
        this.modalStore = new ModalStore_1.default(this);
        this.baseApiService = new BaseApiService_1.BaseApiService(this);
        this.transactionStore = new TransactionStore_1.default(this);
    }
    return RootStore;
}());
exports.RootStore = RootStore;
exports.RootStoreContext = react_1.createContext(new RootStore());
//# sourceMappingURL=RootStore.js.map